<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.8144 20.8156H14.8874L0.449219 0H6.27849L20.8144 20.8156Z" fill="#3B7DD8"/>
<path d="M-0.00190859 20.8156H5.92506L20.3633 0H14.534L-0.00190859 20.8156Z" fill="#FFC53D"/>
</svg>
